import { Divider } from "@material-ui/core";
import React, { useEffect, useState } from "react";

import { useHistory } from "react-router";
import afterLoginApiAxios from "../../../Util/API Calls/afterLogin";
import "../../styles/Settings.scss";
import Loader from "../../UI Component/Loader/Loader";
import { C2CConsole } from "../../../Util/Helper/C2CConsole";

const StaffSettingsOptions = (props) => {
  const { staffDoctor } = props;
  const [status, setStatus] = useState(false);
  const [reminderStatus, setReminderStatus] = useState(false);
  const [staffLogin, setStaffLogin] = useState(false);
  const [notificationAllow, setNotificationAllow] = useState(() => {
    var value = JSON.parse(localStorage.getItem("allowNotification"));
    if (value !== null) return value;
    return true;
  });
  const [myself, setMyself] = useState(false);
  const [myPatients, setMyPatients] = useState(false);

  const [receiveAppNotific, setReceiveAppNotific] = useState(false);
  const [receiveSMS, setReceiveSMS] = useState(false);
  const [scheduled_appointment_updates, setScheduled_appointment_updates] =
    useState(false);
  const [pageLoader, setPageLoader] = useState(false);
  const [autoNoShow, setAutoNoShow] = useState(false);
  const [autoNoShowMins, setAutoNoShowMins] = useState(30);
  const [originalAutoNoShowMins, setOriginalAutoNoShowMins] = useState(30);
  const history = useHistory();

  useEffect(() => {
    setPageLoader(true);
    if (localStorage.getItem("id_token")) {
    } else {
      history.push("/doctor/login");
    }

    afterLoginApiAxios({
      method: "post",
      url: "/doctor/notification-status-rev2",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("id_token"),
      },
      data: {
        // "authorizer-principal-id": {
        //   user_type: "1",
        //   user_id: staffDoctor.id,
        // },
        doctor_id: staffDoctor.id,
      },
    }).then((response) => {
      setStatus(response.data.follow_up_notification_status);
      setReminderStatus(response.data.test_report_notification_status);
      setStaffLogin(response.data.is_staff_enable);
      setMyself(response.data.enable_voice_reminder_doctor);
      setMyPatients(response.data.enable_voice_reminder_patient);
      setReceiveAppNotific(response.data.inclinic_payment_app_notification);
      setReceiveSMS(response.data.inclinic_payment_sms_notification);
      setScheduled_appointment_updates(
        response.data.scheduled_appointment_updates
      );
      setAutoNoShow(response.data.enable_auto_noshow);
      if (response.data.auto_noshow_duration) {
        setAutoNoShowMins(response.data.auto_noshow_duration);
        setOriginalAutoNoShowMins(response.data.auto_noshow_duration);
      }
      setPageLoader(false);
    });
  }, [staffDoctor]);

  const sentFollowUp = () => {
    afterLoginApiAxios({
      method: "post",
      url: "/doctor/notification-status-rev2",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("id_token"),
      },
      data: {
        // "authorizer-principal-id": {
        //   user_type: "1",
        //   user_id: staffDoctor.id,
        // },
        doctor_id: staffDoctor.id,
        follow_up_reminder_to_patients: !status,
        test_report_upload_reminder: reminderStatus,
        scheduled_appointment_updates: scheduled_appointment_updates,
        inclinic_payment_sms_notification: receiveSMS,
        inclinic_payment_app_notification: receiveAppNotific,
        enable_voice_reminder_doctor: myself,
        enable_voice_reminder_patient: myPatients,
        enable_staff_login: staffLogin,
        enable_auto_noshow: autoNoShow,
        auto_noshow_duration: originalAutoNoShowMins,
      },
    })
      .then((response) => {
        setStatus(response.data.follow_up_notification_status);
      })
      .catch((err) => {
        C2CConsole.log(err);
      });
  };

  const sentReminder = () => {
    afterLoginApiAxios({
      method: "post",
      url: "/doctor/notification-status-rev2",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("id_token"),
      },
      data: {
        // "authorizer-principal-id": {
        //   user_type: "1",
        //   user_id: staffDoctor.id,
        // },
        doctor_id: staffDoctor.id,
        follow_up_reminder_to_patients: status,
        test_report_upload_reminder: !reminderStatus,
        scheduled_appointment_updates: scheduled_appointment_updates,
        inclinic_payment_sms_notification: receiveSMS,
        inclinic_payment_app_notification: receiveAppNotific,
        enable_voice_reminder_doctor: myself,
        enable_voice_reminder_patient: myPatients,
        enable_staff_login: staffLogin,
        enable_auto_noshow: autoNoShow,
        auto_noshow_duration: originalAutoNoShowMins,
      },
    })
      .then((response) => {
        setReminderStatus(response.data.test_report_notification_status);
      })
      .catch((err) => {
        C2CConsole.log(err);
      });
  };

  const sentEnable = () => {
    // alert();
    afterLoginApiAxios({
      method: "post",
      url: "/doctor/notification-status-rev2",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("id_token"),
      },
      data: {
        "authorizer-principal-id": {
          user_type: "1",
          user_id: staffDoctor.id,
        },
        follow_up_reminder_to_patients: status,
        test_report_upload_reminder: reminderStatus,
        scheduled_appointment_updates: scheduled_appointment_updates,
        inclinic_payment_sms_notification: receiveSMS,
        inclinic_payment_app_notification: receiveAppNotific,
        enable_voice_reminder_doctor: myself,
        enable_voice_reminder_patient: myPatients,
        enable_staff_login: !staffLogin,
        enable_auto_noshow: autoNoShow,
        auto_noshow_duration: originalAutoNoShowMins,
      },
    })
      .then((response) => {
        setStaffLogin(response.data.is_staff_enable);
      })
      .catch((err) => {
        C2CConsole.log(err);
      });
  };

  let is_doctor = localStorage.getItem("user_type");

  const sentReminderMyself = () => {
    afterLoginApiAxios({
      method: "post",
      url: "/doctor/notification-status-rev2",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("id_token"),
      },
      data: {
        // "authorizer-principal-id": {
        //   user_type: "1",
        //   user_id: staffDoctor.id,
        // },
        doctor_id: staffDoctor.id,
        follow_up_reminder_to_patients: status,
        test_report_upload_reminder: reminderStatus,
        scheduled_appointment_updates: scheduled_appointment_updates,
        inclinic_payment_sms_notification: receiveSMS,
        inclinic_payment_app_notification: receiveAppNotific,
        enable_voice_reminder_doctor: !myself,
        enable_voice_reminder_patient: myPatients,
        enable_staff_login: staffLogin,
        enable_auto_noshow: autoNoShow,
        auto_noshow_duration: originalAutoNoShowMins,
      },
    })
      .then((response) => {
        setMyself(response.data.enable_voice_reminder_doctor);
      })
      .catch((err) => {
        C2CConsole.log(err);
      });
  };

  const sentReminderMyPatients = () => {
    afterLoginApiAxios({
      method: "post",
      url: "/doctor/notification-status-rev2",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("id_token"),
      },
      data: {
        // "authorizer-principal-id": {
        //   user_type: "1",
        //   user_id: staffDoctor.id,
        // },
        doctor_id: staffDoctor.id,
        follow_up_reminder_to_patients: status,
        test_report_upload_reminder: reminderStatus,
        scheduled_appointment_updates: scheduled_appointment_updates,
        inclinic_payment_sms_notification: receiveSMS,
        inclinic_payment_app_notification: receiveAppNotific,
        enable_voice_reminder_doctor: myself,
        enable_voice_reminder_patient: !myPatients,
        enable_staff_login: staffLogin,
        enable_auto_noshow: autoNoShow,
        auto_noshow_duration: originalAutoNoShowMins,
      },
    })
      .then((response) => {
        setMyPatients(response.data.enable_voice_reminder_patient);
      })
      .catch((err) => {
        C2CConsole.log(err);
      });
  };

  const handleReceiveSMS = (e) => {
    setReceiveSMS(e.target.checked);
    afterLoginApiAxios({
      method: "post",
      url: "/doctor/notification-status-rev2",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("id_token"),
      },
      data: {
        // "authorizer-principal-id": {
        //   user_type: "1",
        //   user_id: staffDoctor.id,
        // },
        doctor_id: staffDoctor.id,
        follow_up_reminder_to_patients: status,
        test_report_upload_reminder: reminderStatus,
        scheduled_appointment_updates: scheduled_appointment_updates,
        inclinic_payment_sms_notification: e.target.checked,
        inclinic_payment_app_notification: receiveAppNotific,
        enable_voice_reminder_doctor: myself,
        enable_voice_reminder_patient: myPatients,
        enable_staff_login: staffLogin,
        enable_auto_noshow: autoNoShow,
        auto_noshow_duration: originalAutoNoShowMins,
      },
    })
      .then((response) => {
        setReceiveSMS(response.data.inclinic_payment_sms_notification);
      })
      .catch((err) => {
        C2CConsole.log(err);
      });
  };

  const handleReceiveAppNotification = (e) => {
    setReceiveAppNotific(e.target.checked);
    afterLoginApiAxios({
      method: "post",
      url: "/doctor/notification-status-rev2",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("id_token"),
      },
      data: {
        // "authorizer-principal-id": {
        //   user_type: "1",
        //   user_id: staffDoctor.id,
        // },
        doctor_id: staffDoctor.id,
        follow_up_reminder_to_patients: status,
        test_report_upload_reminder: reminderStatus,
        scheduled_appointment_updates: scheduled_appointment_updates,
        inclinic_payment_sms_notification: receiveSMS,
        inclinic_payment_app_notification: e.target.checked,
        enable_voice_reminder_doctor: myself,
        enable_voice_reminder_patient: myPatients,
        enable_staff_login: staffLogin,
        enable_auto_noshow: autoNoShow,
        auto_noshow_duration: originalAutoNoShowMins,
      },
    })
      .then((response) => {
        setReceiveAppNotific(response.data.inclinic_payment_app_notification);
      })
      .catch((err) => {
        C2CConsole.log(err);
      });
  };

  const handleNotification = (type) => {
    afterLoginApiAxios({
      method: "post",
      url: "/doctor/notification-status-rev2",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("id_token"),
      },
      data: {
        // "authorizer-principal-id": {
        //   user_type: "1",
        //   user_id: staffDoctor.id,
        // },
        doctor_id: staffDoctor.id,
        follow_up_reminder_to_patients: status,
        test_report_upload_reminder: reminderStatus,
        scheduled_appointment_updates: scheduled_appointment_updates,
        inclinic_payment_sms_notification: type === "enable" ? true : false,
        inclinic_payment_app_notification: type === "enable" ? true : false,
        enable_voice_reminder_doctor: myself,
        enable_voice_reminder_patient: myPatients,
        enable_staff_login: staffLogin,
        enable_auto_noshow: autoNoShow,
        auto_noshow_duration: originalAutoNoShowMins,
      },
    })
      .then((response) => {
        setReceiveAppNotific(response.data.inclinic_payment_app_notification);
        setReceiveSMS(response.data.inclinic_payment_sms_notification);
      })
      .catch((err) => {
        C2CConsole.log(err);
      });
  };

  const scheduleAppointUpdate = () => {
    afterLoginApiAxios({
      method: "post",
      url: "/doctor/notification-status-rev2",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("id_token"),
      },
      data: {
        // "authorizer-principal-id": {
        //   user_type: "1",
        //   user_id: staffDoctor.id,
        // },
        doctor_id: staffDoctor.id,
        follow_up_reminder_to_patients: status,
        test_report_upload_reminder: reminderStatus,
        scheduled_appointment_updates: !scheduled_appointment_updates,
        inclinic_payment_sms_notification: receiveSMS,
        inclinic_payment_app_notification: receiveAppNotific,
        enable_voice_reminder_doctor: myself,
        enable_voice_reminder_patient: myPatients,
        enable_staff_login: staffLogin,
        enable_auto_noshow: autoNoShow,
        auto_noshow_duration: originalAutoNoShowMins,
      },
    })
      .then((response) => {
        setScheduled_appointment_updates(
          response.data.scheduled_appointment_updates
        );
      })
      .catch((err) => {
        C2CConsole.log(err);
      });
  };

  const setAutoNoShowDuration = (enable_noshow, noshow_duration) => {
    afterLoginApiAxios({
      method: "post",
      url: "/doctor/notification-status-rev2",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("id_token"),
      },
      data: {
        doctor_id: staffDoctor.id,
        follow_up_reminder_to_patients: status,
        test_report_upload_reminder: reminderStatus,
        scheduled_appointment_updates: scheduled_appointment_updates,
        inclinic_payment_sms_notification: receiveSMS,
        inclinic_payment_app_notification: receiveAppNotific,
        enable_voice_reminder_doctor: myself,
        enable_voice_reminder_patient: myPatients,
        enable_staff_login: staffLogin,
        enable_auto_noshow: enable_noshow,
        auto_noshow_duration: noshow_duration,
      },
    })
      .then((response) => {
        setAutoNoShow(response.data.enable_auto_noshow);
        setAutoNoShowMins(response.data.auto_noshow_duration);
        setOriginalAutoNoShowMins(response.data.auto_noshow_duration);
      })
      .catch((err) => {
        C2CConsole.log(err);
      });
  };

  // Create UI ==>

  const displayAutoNoShowSettings = () => {
    return (
      <div className="mb-3">
        <div className="row m-0 settings-card">
          <div className="col-lg-8">
            <p className="para-text">
              Auto no show for In-Clinic Consultations
            </p>
          </div>
          <div className="col-lg-4 d-flex settings-slider-section">
            <div className="para-text" style={{ paddingTop: "4px" }}>
              {autoNoShow ? <p>Enable</p> : <p>Disable</p>}
            </div>
            <div className="offset-sm-1 para-text settings-slider-align">
              {autoNoShow ? (
                <label class="switch" for="noshow-checkbox">
                  <input
                    className="status-checked"
                    type="noshow-checkbox"
                    id="noshow-checkbox"
                    onClick={() => toggleAutoNoShow()}
                  />
                  <div class="slider round"></div>
                </label>
              ) : (
                <label class="switch" for="noshow-checkbox">
                  <input
                    type="noshow-checkbox"
                    id="noshow-checkbox"
                    onClick={() => toggleAutoNoShow()}
                  />
                  <div class="slider round"></div>
                </label>
              )}
            </div>
          </div>
        </div>
        {autoNoShow ? displayAutoNoShowMins() : null}
      </div>
    );
  };

  const displayAutoNoShowMins = () => {
    return (
      <div className="row m-0 settings-card">
        <Divider />
        <div className="col-lg-12">
          <p className="para-text">
            Consider appointment as no show after{" "}
            <span
              className="auto-noshow-mins"
              style={{
                border:
                  autoNoShowMins < 1 || autoNoShowMins > 360 ? "red" : "none",
              }}
            >
              <input
                type="number"
                value={autoNoShowMins}
                onChange={(e) => handleAutoNoShowMins(e)}
              />
              <span className="vertical-divider"></span>{" "}
              {autoNoShowMins > 1 ? "Mins" : "Min"}
            </span>{" "}
            of consultation start time
            {displayAutoNoShowMinsError()}
          </p>
        </div>
      </div>
    );
  };

  const displayAutoNoShowMinsError = () => {
    let display = null;
    if (autoNoShowMins < 1) {
      display = (
        <span className="auto-noshow-mins-error">{"Value must be > 1"}</span>
      );
    } else if (autoNoShowMins > 360) {
      display = (
        <span className="auto-noshow-mins-error">{"Value must be <= 360"}</span>
      );
    }
    return display;
  };

  // <==

  // Helper methods ==>

  const apiCallForAutoNoShow = (show, duration) => {
    if (show && duration >= 1 && duration < 360) {
      setAutoNoShowDuration(show, duration);
    } else if (!show) {
      setAutoNoShowMins(0);
      setOriginalAutoNoShowMins(0);
      setAutoNoShowDuration(show, 0);
    }
  };

  // <==

  // Actions ==>

  const toggleAutoNoShow = () => {
    let show = !autoNoShow;
    setAutoNoShow(show);
    if (show && !autoNoShowMins) {
      setAutoNoShowMins(30);
      setOriginalAutoNoShowMins(30);
    }
    apiCallForAutoNoShow(show, autoNoShowMins ? autoNoShowMins : 30);
  };

  const handleAutoNoShowMins = (e) => {
    setAutoNoShowMins(e.target.value);
    if (e.target.value >= 1 && e.target.value < 360) {
      setOriginalAutoNoShowMins(e.target.value);
    }
    apiCallForAutoNoShow(autoNoShow, e.target.value);
  };

  // <==

  return (
    <>
      {pageLoader ? (
        <Loader />
      ) : (
        <div className="p-4">
          <div className="row m-0 web_heading d-sm-none d-lg-block d-none">
            <div className="d-flex justify-content-between">
              <div
                className="no-gutters"
                style={{ flex: "1", paddingLeft: "15px" }}
              >
                <p className="notificaton-text mb-1">NOTIFICATION</p>
              </div>
              <div
                className="no-gutters action-text"
                style={{ minWidth: "150px" }}
              >
                <p className="notificaton-text mb-1">ACTION</p>
              </div>
            </div>
          </div>
          <div className="mb-3">
            <div className="row m-0 settings-card">
              <div className="col-lg-8 no-gutters">
                <p className="para-text">
                  Send follow up reminders to patients
                </p>
              </div>
              <div className="col-lg-4 no-gutters flex settings-slider-section">
                <div className="para-text">
                  {status ? <p>Enable</p> : <p>Disable</p>}
                </div>
                <div className="offset-sm-1 para-text settings-slider-align">
                  {status ? (
                    <label class="switch" for="checkbox">
                      <input
                        className="status-checked"
                        type="checkbox"
                        id="checkbox"
                        onClick={() => sentFollowUp()}
                      />
                      <div class="slider round"></div>
                    </label>
                  ) : (
                    <label class="switch" for="checkbox">
                      <input
                        type="checkbox"
                        id="checkbox"
                        onClick={() => sentFollowUp()}
                      />
                      <div class="slider round"></div>
                    </label>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="mb-3">
            <div className="row m-0 settings-card">
              <div className="col-lg-8 no-gutters">
                <p className="para-text">
                  Send Test Report Reminders to Patients
                </p>
              </div>
              <div className="col-lg-4 no-gutters flex settings-slider-section">
                <div className="para-text">
                  {reminderStatus ? <p>Enable</p> : <p>Disable</p>}
                </div>
                <div className="offset-sm-1 para-text settings-slider-align">
                  {reminderStatus ? (
                    <label class="switch" for="reportcheckbox">
                      <input
                        className="status-checked"
                        type="reportcheckbox"
                        id="reportcheckbox"
                        onClick={() => sentReminder()}
                      />
                      <div class="slider round"></div>
                    </label>
                  ) : (
                    <label class="switch" for="reportcheckbox">
                      <input
                        type="reportcheckbox"
                        id="reportcheckbox"
                        onClick={() => sentReminder()}
                      />
                      <div class="slider round"></div>
                    </label>
                  )}
                </div>
              </div>
            </div>
          </div>
          {displayAutoNoShowSettings()}
          <div className="row m-0 mb-3">
            <div className="set_call_reminder p-0">
              <div className="settings-card mobile_height border_bottom">
                <div className="col-sm-12 no-gutters">
                  <p className="para-text">
                    Allow notifications to be sent to you
                  </p>
                </div>
              </div>
              <div className="set_call_reminders_settings_card p-1">
                <div className="set_call_reminders">
                  <div className="row m-0 my_set_call_row">
                    <div className="col-lg-8 no-gutters">
                      <p className="para-text">
                        When the appointments are booked using “Pay at Clinic”
                        payment method
                      </p>
                    </div>
                    <div className="col-lg-4 no-gutters flex settings-slider-section">
                      <div className="para-text">
                        {receiveAppNotific || receiveSMS ? (
                          <p>Enable</p>
                        ) : (
                          <p>Disable</p>
                        )}
                      </div>
                      <div className="offset-sm-1 para-text settings-slider-align">
                        {receiveAppNotific || receiveSMS ? (
                          <label class="switch" for="reportcheckboxMyself">
                            <input
                              className="status-checked"
                              type="reportcheckboxMyself"
                              id="reportcheckboxMyself"
                              onClick={() => handleNotification("disable")}
                            />
                            <div class="slider round"></div>
                          </label>
                        ) : (
                          <label class="switch" for="reportcheckboxMyself">
                            <input
                              type="reportcheckboxMyself"
                              id="reportcheckboxMyself"
                              onClick={() => handleNotification("enable")}
                            />
                            <div class="slider round"></div>
                          </label>
                        )}
                      </div>
                    </div>
                  </div>
                  {receiveAppNotific || receiveSMS ? (
                    <>
                      <div className="row m-0">
                        <div className="col-lg-12 no-gutters d-flex">
                          <label class="container-checkbox">
                            <input
                              type="checkbox"
                              onChange={handleReceiveAppNotification}
                              checked={receiveAppNotific}
                            />
                            <span class="checkmark"></span>
                          </label>
                          <p>Receive app notifications</p>
                        </div>
                      </div>
                      <div className="row m-0 my_set_call_row first">
                        <div className="col-lg-12 no-gutters d-flex">
                          <label class="container-checkbox">
                            <input
                              type="checkbox"
                              onChange={handleReceiveSMS}
                              checked={receiveSMS}
                            />
                            <span class="checkmark"></span>
                          </label>
                          <p>Receive sms</p>
                        </div>
                      </div>
                    </>
                  ) : null}

                  <div className="row m-0 my_set_call_row second">
                    <div className="col-lg-8 no-gutters">
                      <p className="para-text">
                        For updates about scheduled appointments (cancellation,
                        rescheduling etc)
                      </p>
                    </div>
                    <div className="col-lg-4 no-gutters flex settings-slider-section">
                      <div className="para-text">
                        {scheduled_appointment_updates ? (
                          <p>Enable</p>
                        ) : (
                          <p>Disable</p>
                        )}
                      </div>
                      <div className="offset-sm-1 para-text settings-slider-align">
                        {scheduled_appointment_updates ? (
                          <label class="switch" for="reportcheckboxMyPatients">
                            <input
                              className="status-checked"
                              type="reportcheckboxMyPatients"
                              id="reportcheckboxMyPatients"
                              onClick={() => scheduleAppointUpdate()}
                            />
                            <div class="slider round"></div>
                          </label>
                        ) : (
                          <label class="switch" for="reportcheckboxMyPatients">
                            <input
                              type="reportcheckboxMyPatients"
                              id="reportcheckboxMyPatients"
                              onClick={() => scheduleAppointUpdate()}
                            />
                            <div class="slider round"></div>
                          </label>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Set call reminders for online consultations */}
          <div className="row m-0 mb-3">
            <div className="set_call_reminder p-0">
              <div className="settings-card mobile_height border_bottom">
                <div className="col-sm-12 no-gutters">
                  <p className="para-text">
                    Set call reminders for online consultations
                  </p>
                </div>
              </div>
              <div className="set_call_reminders_settings_card p-1">
                <div className="set_call_reminders">
                  <div className="row m-0 my_set_call_row first">
                    <div className="col-lg-8 no-gutters">
                      <p className="para-text">For myself</p>
                    </div>
                    <div className="col-lg-4 no-gutters flex settings-slider-section">
                      <div className="para-text">
                        {myself ? <p>Enable</p> : <p>Disable</p>}
                      </div>
                      <div className="offset-sm-1 para-text settings-slider-align">
                        {myself ? (
                          <label class="switch" for="forMyself">
                            <input
                              className="status-checked"
                              type="forMyself"
                              id="forMyself"
                              onClick={() => sentReminderMyself()}
                            />
                            <div class="slider round"></div>
                          </label>
                        ) : (
                          <label class="switch" for="forMyself">
                            <input
                              type="forMyself"
                              id="forMyself"
                              onClick={() => sentReminderMyself()}
                            />
                            <div class="slider round"></div>
                          </label>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="row m-0 my_set_call_row second">
                    <div className="col-lg-8 no-gutters">
                      <p className="para-text">For my patients</p>
                    </div>
                    <div className="col-lg-4 no-gutters flex settings-slider-section">
                      <div className="para-text">
                        {myPatients ? <p>Enable</p> : <p>Disable</p>}
                      </div>
                      <div className="offset-sm-1 para-text settings-slider-align">
                        {myPatients ? (
                          <label class="switch" for="forMyPatients">
                            <input
                              className="status-checked"
                              type="forMyPatients"
                              id="forMyPatients"
                              onClick={() => sentReminderMyPatients()}
                            />
                            <div class="slider round"></div>
                          </label>
                        ) : (
                          <label class="switch" for="forMyPatients">
                            <input
                              type="forMyPatients"
                              id="forMyPatients"
                              onClick={() => sentReminderMyPatients()}
                            />
                            <div class="slider round"></div>
                          </label>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default StaffSettingsOptions;
